import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nxJsonPretty'
})
export class NxJsonPrettyPipe implements PipeTransform {

  transform(val) {

    return JSON.stringify(val, null, 2)
      .replace(' ', '&nbsp;')
      .replace('\n', '<br/>');
  }
}
